export const ACCESS_TOKEN = 'LyL3dRdeGQoR4zFYs8bYI9Rh9rQqE3OXXSQNzHO8jSU';
export const WEBAPP_BASE_URL = 'https://daily.11sight.com';
export const PROSODY_BASE_URL = 'https://room-daily.11sight.com/';
export const LOGIN_URL = `${WEBAPP_BASE_URL}/oauth/authorize?client_id=r05w5ida9dBCKCZ53FfK0o2AQMh4UdkMnicTKerzjQM&redirect_uri=https%3A%2F%2Froom-daily.11sight.com&response_type=code&scope=vmeet+user_details`;
export const SSO_FRAME_URL = `${WEBAPP_BASE_URL}/oauth/get_token`;
export const FRAME_URL = `${WEBAPP_BASE_URL}/oauth/get_token`;
export const LOGOUT_URL = `${WEBAPP_BASE_URL}/oauth/sign_out`;
export const BASE_URL = 'https://room-daily.11sight.com';
export const AUTHORIZED_ORGANISATIONS = [1, 2];
export const VCALL_CALL_URL = 'https://11to.me';
export const SALE_TEAM_TR = `${VCALL_CALL_URL}/cvbtuyq`;
export const SALE_TEAM_EN = `${VCALL_CALL_URL}/cosnbcp`;
export const xmpp_username_override = 'recorder@recorder.room-daily.11sight.com';
export const xmpp_password_override = 'jibrirecorderpass';
